import DataSource from 'devextreme/data/data_source'
import _productService from 'services/products-services'
import { atomFamily } from 'recoil'
import { handleErrors, loadFn } from 'helpers/custom-data-source'



const appLicensesSource = (VersionSubscriptionId: any) =>


new DataSource({
    key: 'id',
    load: loadFn(_productService.getAppLicenses, { VersionSubscriptionId }),
    insert(device) {
        return _productService.createDevice(device).then(handleErrors)
    },
    update(productDevice) {
        return _productService.updateDevice(productDevice).then(handleErrors)
    },
   
})



export const appLicensesSourceAtom = atomFamily({
key: 'appLicensesSource',
default: (VersionSubscriptionId: any) => appLicensesSource(VersionSubscriptionId),
dangerouslyAllowMutability:true
})